// src/components/EditExperienceRecordModal.jsx

import React, { useState, useEffect } from 'react';
import { FaTimes, FaSave } from 'react-icons/fa';
import './EditExperienceRecordModal.css'; // We will create this next

const EditExperienceRecordModal = ({ record, onSave, onClose }) => {
    const [formData, setFormData] = useState({
        leavingDate: '',
        reasonForLeaving: 'Resigned',
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (record) {
            setFormData({
                leavingDate: record.leavingDate || '',
                reasonForLeaving: record.reasonForLeaving || 'Resigned',
            });
        }
    }, [record]);

    const handleSave = async (e) => {
        e.preventDefault();
        setLoading(true);
        await onSave(record.id, formData);
        setLoading(false);
        onClose();
    };

    if (!record) return null;

    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <button className="close-btn" onClick={onClose} data-tooltip="Close"><FaTimes /></button>
                <h3>Edit Record for: {record.employeeName}</h3>
                <form onSubmit={handleSave} className="control-form">
                    <label htmlFor="leavingDate">Leaving Date</label>
                    <input
                        id="leavingDate"
                        type="date"
                        value={formData.leavingDate}
                        onChange={(e) => setFormData({ ...formData, leavingDate: e.target.value })}
                    />

                    <label htmlFor="reasonForLeaving">Reason for Leaving</label>
                    <select
                        id="reasonForLeaving"
                        value={formData.reasonForLeaving}
                        onChange={(e) => setFormData({ ...formData, reasonForLeaving: e.target.value })}
                    >
                        <option value="Resigned">Resigned</option>
                        <option value="Terminated">Terminated</option>
                        <option value="Contract End">Contract End</option>
                    </select>

                    <button type="submit" className="action-btn-primary" disabled={loading}>
                        <FaSave /> {loading ? 'Saving...' : 'Save Changes'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default EditExperienceRecordModal;